import InterrogationInfoComponentText from '@/view/interrogationInfo/indexText'
const interrogationInfoText = {
    name: 'interrogationInfoText',
    component: InterrogationInfoComponentText,
    meta: {
        title: '填写问诊人信息',
        keepAlive: true
    }
}
export default interrogationInfoText